<ng-container *ngIf="form" [formGroup]="form">
  <div class="grid p-fluid">
      <div class="field col-12 md:col-6">
          <span class="p-float-label p-input-icon-right">
              <input type="text" id="postalCode" mask="00000-000" pInputText formControlName="postalCode"
                [ngClass]="{'ng-invalid ng-dirty': isPostalCodeNotFound}"> 
              <label [ngClass]="{'required': form.get('postalCode')?.hasValidator(validators.required)}" for="postalCode">CEP</label>
              <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
          </span>
          <small class="p-error" *ngIf="isPostalCodeNotFound">CEP não encontrado.</small>
          <small class="address-helper-text" *ngIf="postalCodeHelperText">{{ postalCodeHelperText }}</small>
          <split-control-errors [control]="form.get('postalCode')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="district" pInputText formControlName="district"
                [readonly]="isFieldReadonly('district')"
                [ngClass]="{'p-disabled': isFieldReadonly('district')}"> 
              <label [ngClass]="{'required': form.get('district')?.hasValidator(validators.required)}" for="district">Bairro</label>
          </span>
          <split-control-errors [control]="form.get('district')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <p-dropdown
                  *ngIf="cityStateFieldType === 'dropdown'; else stateInput"
                  appendTo="body"
                  [filter]="true"
                  filterBy="name"
                  [options]="listState"
                  optionLabel="name"
                  optionValue="uf"
                  id="state"
                  formControlName="state"
                  [readonly]="isFieldReadonly('state')"
                  [ngClass]="{'p-disabled': isFieldReadonly('state')}"
              ></p-dropdown>
              <ng-template #stateInput>
                  <input
                    type="text"
                    id="state"
                    pInputText
                    formControlName="state"
                    maxlength="2"
                    [readonly]="isFieldReadonly('state')"
                    [ngClass]="{'p-disabled': isFieldReadonly('state')}">
              </ng-template>
              <label [ngClass]="{'required': form.get('state')?.hasValidator(validators.required)}" for="state">Estado</label>
          </span>
          <split-control-errors [control]="form.get('state')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <p-dropdown
                  *ngIf="cityStateFieldType === 'dropdown'; else cityInput"
                  appendTo="body"
                  [filter]="true"
                  filterBy="nome"
                  [options]="listCity"
                  optionLabel="nome"  
                  optionValue="nome"
                  id="city"
                  formControlName="city"
                  [readonly]="isFieldReadonly('city')"
                  [ngClass]="{'p-disabled': isFieldReadonly('city')}"
              ></p-dropdown>
              <ng-template #cityInput>
                  <input
                    type="text"
                    id="city"
                    pInputText
                    formControlName="city"
                    [readonly]="isFieldReadonly('city')"
                    [ngClass]="{'p-disabled': isFieldReadonly('city')}">
              </ng-template>
              <label [ngClass]="{'required': form.get('city')?.hasValidator(validators.required)}" for="city">Cidade</label>
          </span>
          <split-control-errors [control]="form.get('city')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-12">
          <span class="p-float-label">
              <input type="text" id="streetAddress" pInputText formControlName="streetAddress"
                [readonly]="isFieldReadonly('streetAddress')"
                [ngClass]="{'p-disabled': isFieldReadonly('streetAddress')}"> 
              <label [ngClass]="{'required': form.get('streetAddress')?.hasValidator(validators.required)}" for="streetAddress">Logradouro</label>
          </span>
          <split-control-errors [control]="form.get('streetAddress')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" mask="0*"  id="number" pInputText formControlName="number"
                [readonly]="isFieldReadonly('number')"
                [ngClass]="{'p-disabled': isFieldReadonly('number')}"> 
              <label [ngClass]="{'required': form.get('number')?.hasValidator(validators.required)}" for="number">Numero</label>
          </span>
          <split-control-errors [control]="form.get('number')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="address2" pInputText formControlName="address2"
                [readonly]="isFieldReadonly('address2')"
                [ngClass]="{'p-disabled': isFieldReadonly('address2')}"> 
              <label [ngClass]="{'required': form.get('address2')?.hasValidator(validators.required)}" for="address2">Complemento</label>
          </span>
          <split-control-errors [control]="form.get('address2')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6" *ngIf="showEmail && form.get('email')">
          <span class="p-float-label">
              <input type="email" id="addressEmail" pInputText formControlName="email"
                [readonly]="isFieldReadonly('email')"
                [ngClass]="{'p-disabled': isFieldReadonly('email')}">
              <label [ngClass]="{'required': form.get('email')?.hasValidator(validators.required)}" for="addressEmail">Email</label>
          </span>
          <split-control-errors [control]="form.get('email')"></split-control-errors>
      </div>
  </div>
</ng-container>
